<ng-container *ngIf="state$ | async as state">
  <div [attr.aria-label]="state.video?.title?.trim()?.length ? undefined : 'video'"
       class="modal-header modal-padding"
       data-cy="video-modal-header"
  >
    <button aria-label="Close"
            class="close"
            data-cy="video-modal-close-button"
            data-dismiss="modal"
            type="button"
    >
      <span (click)="close()"
            aria-hidden="true"
            data-cy="video-modal-close-text"
            [innerHTML]="'x'"
      ></span>
    </button>
    <h6 [innerHTML]="'shared.video' | cxTranslate"></h6>
    <div *ngIf="caption?.value?.includes('<h')"
         [data-preview-id]="'#' + caption?.name"
         [id]="'headline-' + state.videoId"
         [innerHTML]="caption?.value | safeHtml"
         data-cy="video-modal-headline"
         class="video-modal-headline"
         mbCmsInnerHTML
    ></div>
    <h4 *ngIf="caption?.value?.length && !caption?.value?.includes('<h')"
        [id]="'headline-' + state.videoId"
        [data-preview-id]="caption.name ? '#' + caption.name : undefined"
        [innerHTML]="caption.value | safeHtml"
        class="video-modal-headline"
        data-cy="video-modal-headline"
        mbCmsInnerHTML
    ></h4>
  </div>
  <div #playerContainer
       class="modal-body modal-padding"
       data-cy="video-modal-body"
  >
    <div [id]="containerId"
         [ucId]="state.videoId"
         [ucService]="ucService.MOVING_IMAGE"
         (unBlocked)="this.videoId$.next(state.videoId)"
         mbUcBlockable
    ></div>
  </div>
  <div class="modal-footer"
       data-cy="video-modal-footer"
  >
    <div *ngIf="description?.value?.trim()?.length"
         [data-preview-id]="description.name ? '#' + description.name : undefined"
         [id]="'description-' + state.videoId"
         [innerHTML]="description.value | safeHtml"
         data-cy="video-modal-description"
         mbCmsInnerHTML
    ></div>
  </div>
</ng-container>
